import React, { useEffect, useState } from "react";
import CustomModalWrap from "../common/CustomModalWrap";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../utils/is-Empty";
import {
  getLoginOtp,
  getRegisterOtp,
  loginUser,
  registerUser,
  verifyOtp,
} from "../../actions/auth.actions";
import { Button, Col, Form, Row } from "react-bootstrap";
import CustomButton from "../common/CustomButton";
import { appConstants, stringConstants } from "../../helpers";
import { capitalize } from "lodash";
import { VerifiedIcon } from "../../assets/svg/svg-icons";
import { Link } from "react-router-dom";
import { formatTimer } from "../../utils/TimestampConverter";

const SellerAuth = ({
  buttonClasses,
  buttonText = "Login",
  registerMode = false,
  selectedCity = "",
  selectedDistrict = "",
  selectedState = "",
  appFeatures,
}) => {
  const dispatch = useDispatch();

  const {
    auth,
    registration,
    roles,
    roletypes,
    getOtp: getOtpDetails,
    verifyOtp: getVerifyOtpDetails,
  } = useSelector((state) => {
    return state;
  });

  const [showRegisterSecondSetp, setShowRegisterSecondSetp] = useState(false);
  const [showRegisterOtp, setShowRegisterOtp] = useState(false);

  const [showOtp, setShowOtp] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [registerObj, setRegisterObj] = useState({});

  const [loginObj, setLoginObj] = useState({});
  const [sellerRoleId, setSellerRoleId] = useState("");
  const [sellerRoleName, setSellerRoleName] = useState("");

  const [termAndCondition, setTermAndCondition] = useState(false);

  const loginClose = () => setShowLogin(false);
  const loginShow = () => setShowLogin(true);

  const registerClose = () => setShowRegister(false);
  const registerShow = () => setShowRegister(true);

  useEffect(() => {
    if (getOtpDetails.otpDetails?.success && showRegister) {
      setShowRegisterOtp(true);
      setOtpTimer(120);
    } else if (getOtpDetails.otpDetails?.success && !showRegister) {
      setShowOtp(true);
      setOtpTimer(120);
    } else {
      setErrorMsg(getOtpDetails.errors?.message);
    }
  }, [getOtpDetails]);

  useEffect(() => {
    if (roles?.data?.length > 0) {
      roles?.data?.map((role) => {
        if (role.role_name === stringConstants.ROLL_SELLER) {
          setSellerRoleName(role.role_name);
          return setSellerRoleId(role.id);
        }
      });
    }
  }, [roles]);

  useEffect(() => {
    if (
      !isEmpty(registerObj) &&
      Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
      Object.prototype.hasOwnProperty.call(registerObj, "email") &&
      !isEmpty(registerObj.mobile_number) &&
      !isEmpty(registerObj.email) &&
      getVerifyOtpDetails.verifyDetails?.success
    ) {
      let updatedObj = {};
      updatedObj["mobile_number_verify_status"] = true;
      updatedObj["email_verify_status"] = true;
      setRegisterObj((previousValues) => ({
        ...previousValues,
        ...updatedObj,
      }));
      setShowRegisterSecondSetp(true);
    } else {
      setShowOtp(false);
      setOtpTimer(0);
      setShowRegisterSecondSetp(false);
      setErrorMsg(getVerifyOtpDetails.errors?.message);
    }
  }, [getVerifyOtpDetails]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (otpTimer > 0) {
        setOtpTimer(otpTimer - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [otpTimer]);

  const onGetRegisterOtp = (e) => {
    setErrorMsg("");
    if (
      !isEmpty(registerObj) &&
      Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
      Object.prototype.hasOwnProperty.call(registerObj, "email") &&
      !isEmpty(registerObj.mobile_number) &&
      !isEmpty(registerObj.email)
    ) {
      let obj = {
        mobile_number: registerObj.mobile_number,
        email: registerObj.email,
      };
      getRegisterOtp(obj, dispatch);
    } else {
      setErrorMsg("Please enter both Mobile Number and Email");
      setOtpTimer(0);
    }
  };
  const onGetLoginOtp = (e) => {
    setErrorMsg("");
    if (
      !isEmpty(loginObj) &&
      Object.prototype.hasOwnProperty.call(loginObj, "userid") &&
      !isEmpty(loginObj.userid)
    ) {
      let obj = {};
      obj[!isNaN(loginObj.userid) ? "mobile_number" : "email"] = loginObj.userid;
      getLoginOtp(obj, dispatch);
    } else {
      setErrorMsg("Please enter email/mobile number");
    }
  };
  const onVerifyOtp = (e) => {
    setErrorMsg("");
    // setRegisterValues("email", { target: { value: "" } });
    if (
      !isEmpty(registerObj) &&
      Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
      Object.prototype.hasOwnProperty.call(registerObj, "email") &&
      !isEmpty(registerObj.mobile_number) &&
      !isEmpty(registerObj.email) &&
      Object.prototype.hasOwnProperty.call(registerObj, "otp") &&
      Object.prototype.hasOwnProperty.call(registerObj, "otp_email") &&
      !isEmpty(registerObj.otp) &&
      !isEmpty(registerObj.otp_email)
    ) {
      let obj = {
        mobile_number: registerObj.mobile_number,
        email: registerObj.email,
        otp: registerObj.otp,
        otp_email: registerObj.otp_email,
      };
      verifyOtp(obj, dispatch);
    } else {
      setErrorMsg("Please enter OTP");
    }
  };

  const setLoginValues = (key, e) => {
    let updatedObj = {};
    updatedObj[key] = e.target.value;

    setLoginObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const setRegisterValues = (key, e) => {
    let updatedObj = {};
    updatedObj[key] = e.target.value;
    setRegisterObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const sellerLogin = (e) => {
    e.preventDefault();
    if (
      !isEmpty(loginObj) &&
      (Object.prototype.hasOwnProperty.call(loginObj, "userid") ||
        Object.prototype.hasOwnProperty.call(loginObj, "otp"))
    ) {
      let obj = {
        otp: loginObj.otp,
      };
      obj[!isNaN(loginObj.userid) ? "mobile_number" : "email"] = loginObj.userid;
      loginUser(obj, dispatch);
    }
  };

  const sellerRegister = (e) => {
    e.preventDefault();
    setErrorMsg("");
    if (
      !isEmpty(registerObj) &&
      termAndCondition &&
      Object.prototype.hasOwnProperty.call(registerObj, "email") &&
      Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
      Object.prototype.hasOwnProperty.call(registerObj, "otp") &&
      Object.prototype.hasOwnProperty.call(registerObj, "otp_email") &&
      Object.prototype.hasOwnProperty.call(registerObj, "business_name") &&
      Object.prototype.hasOwnProperty.call(registerObj, "contact_person_name") &&
      Object.prototype.hasOwnProperty.call(registerObj, "role_type_id") &&
      Object.prototype.hasOwnProperty.call(registerObj, "gst_no")
    ) {
      let obj = {
        business_name: registerObj.business_name,
        email: registerObj.email,
        email_verify_status: registerObj.email_verify_status,
        contact_person_name: registerObj.contact_person_name,
        mobile_number: registerObj.mobile_number,
        mobile_number_verify_status: registerObj.mobile_number_verify_status,
        gst_no: registerObj.gst_no,
        role_id: sellerRoleId,
        role_type_name: sellerRoleName,
        role_type_id: registerObj.role_type_id,
        register_city: selectedCity,
        register_district: selectedDistrict,
        register_state: selectedState,
        app_features: appFeatures.toLowerCase() === "trial" ? "leads" : appFeatures.toLowerCase(),
      };

      console.log("REGISTER OBJ: ", obj);
      registerUser(obj, dispatch);
    } else {
      var validationErrors = [];
      if (!Object.prototype.hasOwnProperty.call(registerObj, "role_type_id")) {
        validationErrors.push("Role Type");
      }
      setErrorMsg("Please select the mandatory fields: " + validationErrors.join(", "));
    }
  };

  const loginModal = (buttonClasses, buttonContant = buttonText) => {
    return (
      <CustomModalWrap
        id="loginModal"
        className="modal-custom-class login-from"
        hedaerContent={
          <>
            <h4>{"Login"}</h4>
            <p
              onClick={() => {
                loginClose();
                registerShow();
                setErrorMsg("");
                setShowOtp(false);
                setOtpTimer(0);
                setRegisterObj({});
              }}
            >
              {"Register Now"}
            </p>
          </>
        }
        buttonClasses={buttonClasses}
        buttonContant={buttonContant}
        isModalOpen={showLogin}
        showModal={() => {
          loginShow();
          setErrorMsg("");
          setLoginObj({});
          setRegisterObj({});
          setShowOtp(false);
          setOtpTimer(0);
        }}
        closeModal={loginClose}
      >
        <Form className="my-2" onSubmit={sellerLogin}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control
              type="text"
              required
              onChange={(e) => setLoginValues("userid", e)}
              placeholder="Enter Mobile Number"
            />
          </Form.Group>
          {errorMsg && <p className="error-msg">{errorMsg}</p>}

          {showOtp && (
            <div className="otp-timer">
              {otpTimer > 0 ? <p>{`00:${otpTimer}`}</p> : <p>Didn't receive otp?</p>}
              <CustomButton
                disabled={otpTimer > 0}
                className="resend-otp-btn"
                style={{
                  color: otpTimer > 0 ? "#DFE3E8" : "#FF5630",
                  visibility: otpTimer > 0 ? "hidden" : "visible",
                }}
                onClick={() => {
                  setOtpTimer(120);
                  onGetLoginOtp();
                }}
              >
                {"Resend OTP"}
              </CustomButton>
            </div>
          )}
          {!showOtp && (
            <CustomButton
              variant="primary"
              buttonClasses="login-btn btn-left"
              loading={getOtpDetails.getOtpLoading}
              type="button"
              onClick={() =>
                Object.prototype.hasOwnProperty.call(loginObj, "userid")
                  ? onGetLoginOtp()
                  : setErrorMsg("Please enter Phone Number")
              }
            >
              {"GET OTP"}
            </CustomButton>
          )}
          {showOtp && (
            <>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  name="otp"
                  maxLength={6}
                  required
                  onChange={(e) => setLoginValues("otp", e)}
                  placeholder="Please fill OTP for login"
                />
              </Form.Group>
              <div className="action-buttons">
                <Button
                  className="reset"
                  variant="primary"
                  onClick={() => {
                    loginClose();
                    setLoginObj({});
                    setShowOtp(false);
                    setOtpTimer(0);
                  }}
                >
                  {"Close"}
                </Button>
                <CustomButton
                  variant="primary"
                  buttonClasses={auth.loginLoading ? "login-loder-btn " : "login"}
                  loading={auth.loginLoading}
                  type="submit"
                >
                  {"Login"}
                </CustomButton>
              </div>
            </>
          )}
        </Form>
      </CustomModalWrap>
    );
  };

  const registerModal = (buttonClasses, buttonContant = buttonText) => {
    return (
      <CustomModalWrap
        className="modal-custom-class "
        hedaerContent={
          <>
            <h4>{"Register"}</h4>

            <p
              onClick={() => {
                registerClose();
                loginShow();
                setShowOtp(false);
                setRegisterObj({});
                setShowRegisterSecondSetp(false);
                setOtpTimer(0);
                setErrorMsg("");
                // dispatch({
                //   type: appConstants.REGISTER_FAILURE,
                //   errors: {},
                // });
              }}
            >
              {"Already have account?"}
            </p>
          </>
        }
        buttonClasses={buttonClasses}
        buttonContant={buttonContant}
        isModalOpen={showRegister}
        showModal={() => {
          registerShow();
          setOtpTimer(0);
          setShowOtp(false);
          setShowRegisterSecondSetp(false);
          setShowRegisterOtp(false);
          setErrorMsg("");
          setRegisterObj({});
        }}
        closeModal={registerClose}
      >
        <h5 className="mb-0">{capitalize(stringConstants.ROLL_SELLER.replace(/_/g, " "))}</h5>
        {!isEmpty(selectedCity) && !isEmpty(selectedDistrict) && !isEmpty(selectedState) && (
          <>
            <p className="fw-bold text-center m-0">
              <small>
                Selected City: {selectedCity}, {selectedDistrict}, {selectedState}
              </small>
            </p>
            <p className="fst-italic text-center mt-0 pt-0">
              <small>
                Register as a seller to get your visibility among buyers across the selected city.
              </small>
            </p>
          </>
        )}
        {showRegisterSecondSetp ? (
          <Form className="my-2" onSubmit={sellerRegister}>
            <Form.Group className="mb-2" controlId="formBasicEmail">
              <Form.Label>
                {"Business Name"}
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={
                  Object.prototype.hasOwnProperty.call(registerObj, "business_name")
                    ? registerObj.business_name
                    : null
                }
                onChange={(e) => setRegisterValues("business_name", e)}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>
                {"Contact Person"}
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
              <Form.Control
                type="text"
                required
                value={
                  Object.prototype.hasOwnProperty.call(registerObj, "contact_person_name") &&
                  !isEmpty(registerObj.contact_person_name)
                    ? registerObj.contact_person_name
                    : null
                }
                onChange={(e) => setRegisterValues("contact_person_name", e)}
              />
            </Form.Group>

            <>
              <Form.Group
                className="mb-2 terms"
                controlId="formBasicCheckbox"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Form.Label>
                  {"Role Type"}
                  <span className="redStreSpan">{"*"}</span>
                  {":"}
                </Form.Label>
                {roletypes?.data?.length > 0 &&
                  roletypes?.data?.map((roletype, index) => {
                    if (roletype.role_id === sellerRoleId) {
                      return (
                        <Form.Check
                          id={roletype.id}
                          key={index}
                          type="radio"
                          name="radio_type"
                          label={roletype.role_type_name}
                          className="square-checkbox mx-2"
                          onChange={(e) =>
                            setRegisterValues("role_type_id", {
                              target: { value: roletype.id },
                            })
                          }
                        />
                      );
                    }
                  })}
              </Form.Group>
            </>

            <Row className="m-0">
              <Col xs={8} className=" left">
                <Form.Group className="mb-2 ">
                  <Form.Label>
                    {"Mobile"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    value={
                      Object.prototype.hasOwnProperty.call(registerObj, "mobile_number")
                        ? registerObj.mobile_number
                        : null
                    }
                    disabled
                    onChange={(e) => setRegisterValues("mobile_number", e)}
                  />
                </Form.Group>
              </Col>
              <Col xs={4} className=" right d-flex pt-3 " style={{ alignItems: "center" }}>
                <span className="me-2 ">{"Verified"}</span>
                <VerifiedIcon />
              </Col>
            </Row>

            <Row className="m-0">
              <Col xs={8} className=" left">
                <Form.Group className="mb-2" controlId="formBasicEmail">
                  <Form.Label>
                    {"Email ID"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    required
                    value={
                      Object.prototype.hasOwnProperty.call(registerObj, "email")
                        ? registerObj.email
                        : null
                    }
                    onChange={(e) => setRegisterValues("email", e)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col xs={4} className=" right d-flex pt-3 " style={{ alignItems: "center" }}>
                <span className="me-2 ">{"Verified"}</span>
                <VerifiedIcon />
              </Col>
            </Row>

            <Form.Group className="mb-1 terms pb-0 term d-flex" controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label={
                  <p>
                    <Link target="_blank" to={"/terms#seller-delivery-policies"}>
                      {"Terms of Use"}
                    </Link>
                    {" & "}{" "}
                    <Link target="_blank" to={"/privacy-policy"}>
                      {"Privacy Policy"}
                    </Link>
                  </p>
                }
                required
                onChange={(e) => {
                  setTermAndCondition(e.target.checked);
                }}
              />
              <Form.Label>
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
              {/* {`Terms  of use & Privacy Policy `}<span className="redStreSpan">{"*"}</span></Form.Check> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                {"GST No."}
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
      <Form.Control
  type="text"
  maxLength={15}
  value={
    Object.prototype.hasOwnProperty.call(registerObj, "gst_no")
      ? registerObj.gst_no
      : ""
  }
  onChange={(e) => {
    e.target.value = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 15);

    setRegisterValues("gst_no", e);
  }}
  placeholder="Enter GST No."
/>
            </Form.Group>

            {registration?.errors?.message && (
              <p className="error-msg">{registration?.errors?.message}</p>
            )}
            {errorMsg && <p className="error-msg">{errorMsg}</p>}

            <div className="action-buttons">
              <p className="m-0">
                <span className="redStreSpan">{"*"}</span>
                {" Mandatory Field"}
              </p>
              <Button
                className="reset"
                variant="primary"
                onClick={() => {
                  registerClose();
                  setShowOtp(false);
                  setRegisterObj({});
                  setShowRegisterSecondSetp(false);
                  setOtpTimer(0);
                  setErrorMsg("");
                  dispatch({
                    type: appConstants.REGISTER_FAILURE,
                    errors: {},
                  });
                }}
              >
                {"Close"}
              </Button>
              <Button
                className="login"
                variant="primary"
                type="submit"
                // disabled={!showOtp ? true : false}
              >
                {"Register"}
              </Button>
            </div>
          </Form>
        ) : (
          <Form className="my-2">
            <h6 className="text-center">{"Verify Mobile Number & Email"}</h6>
            {showRegisterOtp && (
              <div className="otp-timer my-1">
                {otpTimer > 0 ? (
                  <p>Resend OTP in {`${formatTimer(otpTimer)}`}</p>
                ) : (
                  <p>Didn't receive otp?</p>
                )}
                <Button
                  disabled={otpTimer > 0}
                  className="resend-otp-btn"
                  style={{
                    color: otpTimer > 0 ? "#DFE3E8" : "#FF5630",
                    visibility: otpTimer > 0 ? "hidden" : "visible",
                  }}
                  onClick={() => {
                    setOtpTimer(120);
                    onGetRegisterOtp();
                  }}
                >
                  {"Resend OTP"}
                </Button>
              </div>
            )}
            <Form.Group className="mb-3 ">
              <Form.Label>
                {"Mobile"}
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={10}
                value={
                  Object.prototype.hasOwnProperty.call(registerObj, "mobile_number")
                    ? registerObj.mobile_number
                    : null
                }
                onChange={(e) => setRegisterValues("mobile_number", e)}
                disabled={showRegisterOtp ? true : false}
              />
            </Form.Group>

            <Form.Group className="mb-3 ">
              <Form.Label>
                {"Email"}
                <span className="redStreSpan">{"*"}</span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                value={
                  Object.prototype.hasOwnProperty.call(registerObj, "email")
                    ? registerObj.email
                    : null
                }
                onChange={(e) => setRegisterValues("email", e)}
                disabled={showRegisterOtp ? true : false}
              />
            </Form.Group>

            {!showRegisterOtp && (
              <Form.Group className="mb-3  w-100">
                <Form.Label>{"Generate OTP"}</Form.Label>
                <CustomButton
                  variant="primary"
                  buttonClasses="login-btn btn-left"
                  loading={getOtpDetails.getOtpLoading}
                  type="button"
                  onClick={() =>
                    Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
                    Object.prototype.hasOwnProperty.call(registerObj, "email")
                      ? onGetRegisterOtp()
                      : setErrorMsg("Please enter both Phone Number and Email")
                  }
                >
                  {"GET OTP"}
                </CustomButton>
              </Form.Group>
            )}

            {showRegisterOtp && (
              <>
                <Form.Group className="mb-3 ">
                  <Form.Label>
                    {"Mobile OTP"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={6}
                    value={
                      Object.prototype.hasOwnProperty.call(registerObj, "otp")
                        ? registerObj.otp
                        : null
                    }
                    onChange={(e) => setRegisterValues("otp", e)}
                  />
                </Form.Group>
                <Form.Group className="mb-3 ">
                  <Form.Label>
                    {"Email OTP"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={6}
                    value={
                      Object.prototype.hasOwnProperty.call(registerObj, "otp_email")
                        ? registerObj.otp_email
                        : null
                    }
                    onChange={(e) => setRegisterValues("otp_email", e)}
                  />
                </Form.Group>
                <CustomButton
                  variant="primary"
                  buttonClasses="login-btn"
                  loading={getVerifyOtpDetails.verifyOtpLoading}
                  type="button"
                  onClick={() =>
                    Object.prototype.hasOwnProperty.call(registerObj, "mobile_number") &&
                    Object.prototype.hasOwnProperty.call(registerObj, "email")
                      ? onVerifyOtp()
                      : setErrorMsg("Please enter Phone Number and Email")
                  }
                >
                  {"Verify OTP"}
                </CustomButton>
              </>
            )}
            {errorMsg && <p className="error-msg">{errorMsg}</p>}
          </Form>
        )}
      </CustomModalWrap>
    );
  };

  return (
    <>
      {registerModal(registerMode ? buttonClasses : "hidden", buttonText)}
      {loginModal(!registerMode ? buttonClasses : "hidden", buttonText)}
    </>
  );
};

export default SellerAuth;
